export const JUSBRASIL_DOMAIN = 'jusbrasil.com.br'

export const PRODUCTION_HOST = `www.${JUSBRASIL_DOMAIN}`
export const PRODUCTION_ORIGIN = `https://${PRODUCTION_HOST}`
